import React from 'react';
import LanguageContext from '../../contexts/LanguageContext';
import { apiTestingTranslator } from '../../translations/apiTesting';
import { Alert, AlertDescription } from '../ui/alert';
import { Button } from '../ui/button';
import { AlertTriangle } from 'lucide-react';

// Error Boundary Component
export default class APITestingErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('APITesting Error Boundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  static contextType = LanguageContext;

  render() {
    const t = apiTestingTranslator(this.context?.language);
    if (this.state.hasError) {
      return (
        <div className="p-6">
          <Alert className="border-red-200 bg-red-50">
            <AlertTriangle className="h-4 w-4 text-red-600" />
            <AlertDescription>
              <div className="text-red-800">
                <h3 className="font-semibold mb-2">{t("Something went wrong with the API Testing interface")}</h3>
                <p className="mb-3">{t("Please refresh the page to continue. If the problem persists, please contact support.")}</p>
                <Button
                  onClick={() => window.location.reload()}
                  className="bg-red-600 hover:bg-red-700 text-white"
                >
                  {t("Refresh Page")}
                </Button>
              </div>
            </AlertDescription>
          </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}
